import { render, staticRenderFns } from "./unseal.vue?vue&type=template&id=27c2a54a&scoped=true&"
import script from "./unseal.vue?vue&type=script&lang=js&"
export * from "./unseal.vue?vue&type=script&lang=js&"
import style0 from "./unseal.vue?vue&type=style&index=0&id=27c2a54a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c2a54a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27c2a54a')) {
      api.createRecord('27c2a54a', component.options)
    } else {
      api.reload('27c2a54a', component.options)
    }
    module.hot.accept("./unseal.vue?vue&type=template&id=27c2a54a&scoped=true&", function () {
      api.rerender('27c2a54a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gmToolNew/allianceIntroductionApproval/components/unseal.vue"
export default component.exports